import React, { useState } from 'react'
import Modal from '../../../../components/UI/Modal/Modal'
import { withTranslate } from 'react-redux-multilingual'
import { Button, Grid, Box, Paper } from '@material-ui/core/'
import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Form from './Form/Form'
import Chart from './Chart/Chart'
import ReactSpeedometer from 'react-d3-speedometer'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import Collapse from './Collapse/Collapse'
import NoDataDisplay from '../../../NoDataDisplay/NoDataDisplay'
import { makeStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

// icon
import TabIcon from '@material-ui/icons/Tab'
import AddBoxIcon from '@material-ui/icons/AddBox'
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'

// icon button
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import { ResponsiveContainer } from 'recharts'

const useStyles = makeStyles({
  prev: {
    position: 'absolute',
    top: '50%',
    left: '5px',
    // transform: 'translate(-10%, -50%)',
    zIndex: 1,
    backgroundColor: '#DDDDDD',
    opacity: '40%',
    '&:hover': {
      opacity: '100%',
      boxShadow: '0 8px 6px -6px #000000'
    }
  },
  prevText: {
    position: 'absolute',
    top: '50%',
    left: '20px',
    // transform: 'translate(-10%, -50%)',
    zIndex: 1,
    opacity: '60%'
  },
  next: {
    position: 'absolute',
    top: '50%',
    right: '5px',
    // transform: 'translate(-10%, -50%)',
    zIndex: 1,
    backgroundColor: '#DDDDDD',
    opacity: '40%',
    '&:hover': {
      opacity: '100%',
      boxShadow: '0 8px 6px -6px #000000'
    }
  },
  nextText: {
    position: 'absolute',
    top: '50%',
    right: '20px',
    // transform: 'translate(-10%, -50%)',
    zIndex: 1,
    opacity: '60%'
  },
  chartNewSize: {
    width: '515px',
    height: '400px'
  },
  chart: {
    height: '400px'
  },
  scroll: {
    overflow: 'scroll'
  }
})

function PerformanceTrendContent(props) {
  const matches = useMediaQuery('(max-width:666px)')
  const classes = useStyles()
  // State Modal
  const [modalOpen, setModalOpen] = useState(false)
  // State Button (Expand/Collapse)
  const [expanded, setExpanded] = useState(false)
  // State Expand/Collapse
  const [collapse, setCollapse] = useState(true)
  // const [title, setTitle] = useState('Expand All')
  // const [icon, setIcon] = useState(<AddBoxIcon />)

  // Function Expand/Collapse
  const collapseAll = () => {
    setCollapse(!collapse)
    // setExpanded(!expanded)
    setExpanded()
  }

  const openModal = () => {
    setModalOpen(true)
  }

  const closeModal = () => {
    setModalOpen(false)
  }

  // start next & prev
  // **********************************

  // select item
  let selected = props.filterControls?.item_id?.value

  // find index
  let index = props.filterControls?.item_id?.configs?.options.findIndex(
    item => item.key === selected?.key
  )

  let data = props.filterControls?.item_id?.configs?.options

  const next = () => {
    let nextItem = null
    nextItem = data[index + 1]
    let param = {
      company_id: props.filterControls?.company_id?.value?.value,
      appraisal_type_id: props.filterControls?.appraisal_type_id?.value?.value,
      form_id: props.filterControls?.form_id?.value?.value,
      structure_id: props.filterControls?.structure_id?.value?.value,
      org_id: props.filterControls?.org_id?.value?.value,
      emp_detail_id: props.filterControls?.emp_detail_id?.value?.value,
      item_id: props.filterControls?.item_id?.value?.value
    }
    param = {
      ...param,
      item_id: nextItem?.value
    }

    props.fetchDashboardPerformanceTrendChart(param)

    // return value to PerformanceTrend
    props.getItem(nextItem)
  }

  const prev = () => {
    let nextItem = null
    nextItem = data[index - 1]

    let param = {
      company_id: props.filterControls?.company_id?.value?.value,
      appraisal_type_id: props.filterControls?.appraisal_type_id?.value?.value,
      form_id: props.filterControls?.form_id?.value?.value,
      structure_id: props.filterControls?.structure_id?.value?.value,
      org_id: props.filterControls?.org_id?.value?.value,
      emp_detail_id: props.filterControls?.emp_detail_id?.value?.value,
      item_id: props.filterControls?.item_id?.value?.value
    }
    param = {
      ...param,
      item_id: nextItem?.value
    }

    props.fetchDashboardPerformanceTrendChart(param)

    // return value to PerformanceTrend
    props.getItem(nextItem)
  }

  // end next & prev
  // **********************************
  const validButton = type => {
    if (type === 'next') {
      return (
        props.filterControls?.item_id?.configs?.options.findIndex(
          item => item.key === props.filterControls?.item_id?.value?.key
        ) +
          1 >=
        props.filterControls?.item_id?.configs?.options.length
      )
    }
    if (type === 'prev') {
      return (
        props.filterControls?.item_id?.configs?.options.findIndex(
          item => item.key === props.filterControls?.item_id?.value?.key
        ) <= 0
      )
    }
  }
  const renderCollapse = (data, index) => {
    const {
      // Data For Collapse
      actual_value,
      target_value,
      uom_name,
      item_name,
      date,
      perspective_name,
      org_name,
      emp_name,
      percent_achievement,

      // Data For Gauge
      customSegmentStop,
      segmentColors,
      maxValue,
      minValue
    } = data

    return (
      <Aux>
        {index === 0 ? (
          <Collapse
            key={index}
            title={org_name || emp_name || ''}
            show={expanded}
            style={{ position: 'relative', zIndex: 0 }}>
            <Typography className={classes.prevText} variant='caption' display='block'>
              {props.filterControls?.item_id?.configs?.options.findIndex(
                item => item.key === props.filterControls?.item_id?.value?.key
              ) + 1}
              /{props.filterControls?.item_id?.configs?.options.length}
            </Typography>
            <IconButton
              className={classes.prev}
              disabled={validButton('prev')}
              onClick={() => {
                prev()
              }}>
              {/* <Grid container direction='column'>
                <Grid item> */}

              {/* </Grid>
                <Grid item> */}
              <NavigateBeforeIcon />
              {/* </Grid>
              </Grid> */}
            </IconButton>
            <Typography className={classes.nextText} variant='caption' display='block'>
              {props.filterControls?.item_id?.configs?.options.findIndex(
                item => item.key === props.filterControls?.item_id?.value?.key
              ) + 1}
              /{props.filterControls?.item_id?.configs?.options.length}
            </Typography>
            <IconButton
              className={classes.next}
              disabled={validButton('next')}
              onClick={() => {
                next()
              }}>
              <NavigateNextIcon />
            </IconButton>
            <Grid container spacing={3}>
              <Grid item xs={12} md={5}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <p>
                      {`${perspective_name} - ${item_name}(${props.translate('uom')}: ${uom_name})`}
                    </p>
                    <p style={{ color: 'blue' }}>{`${props.translate('atDate')}: ${date}`}</p>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper>
                      <Box>
                        {/* เป้า  */}
                        {props.translate('target')}
                        <br />
                        {target_value
                          ? parseFloat(target_value)
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                          : ''}
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper>
                      <Box>
                        {/* ผลงาน */}
                        {props.translate('actual')} <br />
                        {actual_value
                          ? parseFloat(actual_value)
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                          : ''}
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    {/* Gauge Meter */}
                    <div
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <div style={{ width: '24em', height: '14em', paddingTop: '5px' }}>
                        <ResponsiveContainer>
                          <ReactSpeedometer
                            needleHeightRatio={0.7}
                            customSegmentStops={customSegmentStop}
                            segmentColors={segmentColors}
                            value={percent_achievement}
                            maxValue={maxValue}
                            minValue={minValue}
                            textColor={'black'}
                            needleColor={'black'}
                            forceRender={true}
                          />
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={7} className={classes.scroll}>
                <Paper className={matches ? classes.chartNewSize : classes.chart}>
                  <Chart key={index} chartData={data} />
                </Paper>
              </Grid>
            </Grid>
          </Collapse>
        ) : (
          <Collapse key={index} title={org_name || emp_name || ''} show={collapse}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={5}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <p>{`${perspective_name} - ${item_name}(${props.translate(
                      'uom'
                    )}: ${uom_name})`}</p>
                    <p style={{ color: 'blue' }}>{`${props.translate('atDate')}: ${date}`}</p>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper>
                      <Box>
                        {/* เป้า  */}
                        {props.translate('target')}
                        <br />
                        {target_value
                          ? parseFloat(target_value)
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                          : ''}
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper>
                      <Box>
                        {/* ผลงาน */}
                        {props.translate('actual')} <br />
                        {actual_value
                          ? parseFloat(actual_value)
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                          : ''}
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    {/* Gauge Meter */}
                    <div
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <div style={{ width: '24em', height: '14em', paddingTop: '5px' }}>
                        <ResponsiveContainer>
                          <ReactSpeedometer
                            needleHeightRatio={0.7}
                            customSegmentStops={customSegmentStop}
                            segmentColors={segmentColors}
                            value={percent_achievement}
                            maxValue={maxValue}
                            minValue={minValue}
                            textColor={'black'}
                            needleColor={'black'}
                            forceRender={true}
                          />
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={7} className={classes.scroll}>
                {/* Chart Data */}
                <Paper className={matches ? classes.chartNewSize : classes.chart}>
                  <Chart key={index} chartData={data} />
                </Paper>
              </Grid>
            </Grid>
          </Collapse>
        )}
      </Aux>
    )
  }

  return (
    <div>
      <Modal
        open={modalOpen}
        onHide={closeModal}
        header={props.translate('allKpi')}
        backdropClicked={closeModal}
        size={'xl'}
        buttonClose={true}>
        <div className={classes.ModalBody}>
          {!props.formLoading ? <Form allData={props.allData} /> : <Spinner />}
        </div>
      </Modal>
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        {collapse === true ? (
          <Button variant='outlined' startIcon={<AddBoxIcon />} onClick={collapseAll}>
            {props.translate('expandAll')}
          </Button>
        ) : (
          <Button
            variant='outlined'
            startIcon={<IndeterminateCheckBoxIcon />}
            onClick={collapseAll}>
            {props.translate('collapseAll')}
          </Button>
        )}
        &nbsp;
        <Button
          variant='outlined'
          startIcon={<TabIcon />}
          onClick={() => {
            openModal()
          }}>
          {/* ตัวชี้วัดทั้งหมด */}
          {props.translate('allKpi')}
        </Button>
      </div>
      <br />
      {props.chartData !== 0 ? (
        <div>{props.chartData?.map((r, index) => renderCollapse(r, index))}</div>
      ) : (
        <NoDataDisplay />
      )}
    </div>
  )
}
export default withTranslate(PerformanceTrendContent)
